let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("b4NO6"), load("3fLE9"), load("fM2oh"), load("guNAg"), load("ik6u5")]).then(() => parcelRequire('k5UMG'));